import { render } from "./PaymentForms.vue?vue&type=template&id=7539b4a0&scoped=true"
import script from "./PaymentForms.vue?vue&type=script&lang=js"
export * from "./PaymentForms.vue?vue&type=script&lang=js"

import "./PaymentForms.vue?vue&type=style&index=0&id=7539b4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7539b4a0"]])

export default __exports__